import { createServiceToken } from '../runtime';
import type {
  IConfigService,
  IAuthSessionService,
  IMockStoreService,
  IPresenceService,
  IScopeService,
} from '../contracts';

export const CONFIG_TOKEN = createServiceToken<IConfigService>('ConfigService');
export const AUTH_TOKEN = createServiceToken<IAuthSessionService>('AuthSessionService');
export const MOCK_STORE_TOKEN = createServiceToken<IMockStoreService>('MockStoreService');
export const PRESENCE_TOKEN = createServiceToken<IPresenceService>('PresenceService');
export const SCOPE_TOKEN = createServiceToken<IScopeService>('ScopeService');
